import { render } from "./MentoringDetailsSubDialog.vue?vue&type=template&id=a4e55dd2"
import script from "./MentoringDetailsSubDialog.vue?vue&type=script&lang=js"
export * from "./MentoringDetailsSubDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__